import Layout from "../components/Layout";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import EmpAssessmentCard from "../components/EmpAssessmentCard";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import EmpInfoCard from "../components/EmpInfoCard";
import './SupervisorAssessmentPage.css'

import { toast } from 'react-toastify'

const SupervisorAssessmentPage = () => {
    const primeToast = useRef(null)
    const { user } = useSelector(state => state['auth']);
    const [optionList, setOptionList] = useState([]);
    const [quater, setQuater] = useState([])
    const [assessmentIndicator, setAssessmentIndicator] = useState({ isLoading: false, list: [] })
    const [employees, setEmployees] = useState([])
    const [employeeAssessment, setEmployeeAssessment] = useState([])
    const [supervisorAssessment, setSupervisorAssessment] = useState([]);
    const [supervisorUpdateCount, setSupervisorUpdateCount] = useState([])
    const [isAssessmentLoading, setIsAssessmentLoading] = useState(false)

    const successNotify = (message) => toast.info(message);
    const errorNotify = (message) => toast.error(message);



    useEffect(() => {
        console.log("SupervisorAssessmentPage")
        loadEmployeeAssessment()
        getAssesstmentOpinionList();
        getQuarterActiveList()
    }, [])


    const updateSupervisorAssessment = (list) => {
        if (list.length !== 0) {
            const funckingAssessment = []
            list.map(item => {
                if (item.userAssestmentOpinionID !== null) {
                    funckingAssessment.push({
                        opinionID: item.userAssestmentOpinionID,
                        assesmentInformationID: item.assesmentInformationID,
                        registerID: user.registerID
                    })
                }

            });
            setSupervisorAssessment(funckingAssessment)
            //set state
        }
    }

    const getEmployeeAssessment = (id) => {
        setIsAssessmentLoading(true)
        axios.get(BASE_URL + "/api/utility/SupervisorSelectedEmployee/" + id)
            .then(response => {
                console.log(response.data);
                setIsAssessmentLoading(false)
                setEmployeeAssessment(response.data)
                updateSupervisorAssessment(response.data)
                //console.log(response.data.length)
            })
            .catch(e => {
                setIsAssessmentLoading(false)
                console.log(e)
            })
    }

    const getQuarterActiveList = () => {
        axios.get(BASE_URL + "/api/quarter/GetActiveList")
            .then(response => {
                setQuater(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getAssessmentIndicator = (id) => {
        setAssessmentIndicator({ isLoading: true, list: [] })
        axios.get(BASE_URL + "/api/utility/GetAssestmentIndicator/" + id)
            .then(response => {
                setAssessmentIndicator({ isLoading: false, list: response.data })
            })
            .catch(e => {
                setAssessmentIndicator({ isLoading: false, list: [] })
                console.log(e)
            })
    }

    const onEmployeeSelect = (e) => {
        const registerId = e.currentTarget.value
        //console.log("Forhad ->"+registerId)
        setSupervisorAssessment([])
        setEmployeeAssessment([])
        if (registerId > 0) {
            getEmployeeAssessment(registerId)
            SupervisorUpdateCount(registerId)
        } else {
            setEmployeeAssessment([])
        }
    }

    const loadEmployeeAssessment = () => {
        axios.get(BASE_URL + "/api/utility/SupervisorAssestmentList/" + user.registerID)
            .then(response => {
                setEmployees(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getAssesstmentOpinionList = () => {
        axios.get(BASE_URL + "/api/assestmentOpinion/GetActiveList")
            .then(response => {
                setOptionList(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }


    const onSupervisorOpinionChange = (weight, assessmentItem) => {

        if (supervisorAssessment.length === 0) {
            setSupervisorAssessment([...supervisorAssessment,
            {
                opinionID: weight,
                assesmentInformationID: assessmentItem.assesmentInformationID,
                registerID: user.registerID
            }])
        } else {
            const existResult = supervisorAssessment.filter(item => item.assesmentInformationID === assessmentItem.assesmentInformationID);
            if (existResult.length === 0) {
                setSupervisorAssessment([...supervisorAssessment,
                {
                    opinionID: weight,
                    assesmentInformationID: assessmentItem.assesmentInformationID,
                    registerID: user.registerID
                }])
            } else {
                const filterResult = supervisorAssessment.filter(item => item.assesmentInformationID !== assessmentItem.assesmentInformationID);
                filterResult.push({
                    opinionID: weight,
                    assesmentInformationID: assessmentItem.assesmentInformationID,
                    registerID: user.registerID
                })
                setSupervisorAssessment(filterResult)
            }
        }


    }

    const SupervisorUpdateCount = (id) => {
        console.log("Register id===>" + id)
        axios.get(BASE_URL + "/api/supervisor/SupervisorUpdateCount/" + id)
            .then(response => {
                setSupervisorUpdateCount(response.data)
            }).catch(e => {
                console.log(e)
            })
    }


    const saveAssessment = async () => {
        try {

            const unsetOpinion = supervisorAssessment.filter(item => Number(item.opinionID) === -1)

            console.log(JSON.stringify(supervisorAssessment))

            if (employeeAssessment.length > supervisorAssessment.length) {
                //show toast please complete all assessment

                errorNotify("please complete all assessment");

                // primeToast.current.show({
                //     severity: 'error',
                //     summary: 'error',
                //     detail: 'please complete all assessment',
                //     life: 3000
                // });
                return;
            } else if (unsetOpinion.length > 0) {

                errorNotify("please complete all assessment");

                // primeToast.current.show({
                //     severity: 'error',
                //     summary: 'error',
                //     detail: 'please complete all assessment',
                //     life: 3000
                // });
                return
            } else {
                const response = await axios.post(BASE_URL + '/api/assesmentinformation/SetSupervisorAssesment', supervisorAssessment);
                if (response.status === 200) {
                    console.log("Save success.");

                    successNotify("Data saved successfully.");

                    // primeToast.current.show({
                    //     severity:'success',
                    //     summary:'success',
                    //     detail:'Data saved successfully.',
                    //     life:3000
                    // })
                }
            }


        } catch (e) {
            console.log(e)
        }

    }


    return (
        <Layout>
            <Toast ref={primeToast} />
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-3">
                            <select id="ddlEmployee" name="ddlEmployee" className="form-select" onChange={onEmployeeSelect}
                                aria-label=".form-select-sm example">
                                <option value={-1}>{"Select Employee"}</option>
                                {employees.map((value, index) => <option key={index}
                                    value={value.registerID}>{value.employeeName}</option>)}
                            </select>
                        </div>
                        <div className="col-md-2">
                            {
                                user.isLocked === true ? (
                                    <h4 className="notUpdateComment" style={{ fontSize: ".8rem" }}>
                                        *** This Quarter Already Locked..!
                                    </h4>
                                ) :
                                    (
                                        <button onClick={saveAssessment} className="btn btn-primary"><i className="bi bi-check-lg" /> Save</button>
                                    )
                            }

                        </div>
                        <div className="col-md-3" style={{ textAlign: 'right', fontSize: '.85rem' }}>
                            {supervisorUpdateCount.length === 0 ? "" :
                                <b>You have Completed {supervisorUpdateCount[0].totalSupervisorComplete} out
                                    of {supervisorUpdateCount[0].totalAssestment}</b>
                            }

                        </div>
                        <div className="col-md-4" style={{ textAlign: 'right', fontSize: '.85rem' }}>
                            <b>Quarter:</b> {user.quarterName}/{new Date().getFullYear()}
                        </div>

                    </div>

                </div>

                <div className="card-body">
                    {employeeAssessment.length !== 0 ?
                        <EmpInfoCard empName={employeeAssessment[0].employeeName}
                            department={employeeAssessment[0].department}
                            designation={employeeAssessment[0].designation}
                            email={employeeAssessment[0].email} />
                        : (<div className="p-5"><h3>Supervisor <b>CORE VALUES</b> Assessment Area</h3></div>)}
                    {isAssessmentLoading ? <ProgressSpinner style={{ width: 20, height: 20 }} /> : ""}
                    {employeeAssessment.length !== 0 ? <div className="row">
                        {employeeAssessment.map((value, index) => <div key={index} className="col-md-4">
                            <EmpAssessmentCard
                                assessmentItem={value}
                                optionList={optionList}
                                onSupervisorOpinionChange={onSupervisorOpinionChange} />

                        </div>)}

                    </div> : <div></div>}


                </div>

            </div>
        </Layout>
    )


}


export default SupervisorAssessmentPage